export default {
  setSession(key, obj) {
    sessionStorage.setItem(key, JSON.stringify(obj))
  },
  getSession(key) {
    let obj = sessionStorage.getItem(key)
    return JSON.parse(obj)
  },
  showToast(txt){
    this.$createToast({
      txt: txt,
      type: 'txt',
      time: 3000,
    }).show()
  },
}
